import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'burger']

  toggle () {
    if (this.burgerTarget.classList.contains('open')) {
      // close
      this.menuTarget.classList.add('hidden')
      this.burgerTarget.classList.remove('open')
    } else {
      // open
      this.menuTarget.classList.remove('hidden')
      this.burgerTarget.classList.add('open')
    }
  }
}
